import { z } from 'zod';

export const MAX_VIDEO_NAME_LENGTH = 120;
/** Longest walk-through recording accepted (15 minutes, plus a little slack). */
export const MAX_VIDEO_DURATION_MS = 15 * 60 * 1000 + 5000;

/** Walk-through video saved with a project. */
export const videoDtoSchema = z.object({
  id: z.string(),
  projectId: z.string(),
  name: z.string(),
  mimeType: z.string(),
  sizeBytes: z.number().int(),
  durationMs: z.number().int(),
  withSound: z.boolean(),
  createdAt: z.string(),
  /** Display name of whoever recorded it. */
  createdBy: z.string(),
});
export type VideoDto = z.infer<typeof videoDtoSchema>;

export const videoListResponseSchema = z.object({
  videos: z.array(videoDtoSchema),
  /** Storage taken by the requesting user's videos, and the limits. */
  usedBytes: z.number(),
  quotaBytes: z.number(),
  maxVideoBytes: z.number(),
});
export type VideoListResponse = z.infer<typeof videoListResponseSchema>;

export const videoResponseSchema = z.object({ video: videoDtoSchema });

export const renameVideoRequestSchema = z.object({
  name: z.string().trim().min(1).max(MAX_VIDEO_NAME_LENGTH),
});
